import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right-simple",
  "use": "arrow-right-simple-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" fill=\"none\" id=\"arrow-right-simple\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.4262 14L16 15.4262L11.7215 19.7046C11.3277 20.0985 10.6892 20.0985 10.2954 19.7046C9.90154 19.3108 9.90154 18.6723 10.2954 18.2785L14.5738 14L10.2954 9.72153C9.90154 9.3277 9.90154 8.68919 10.2954 8.29537C10.6892 7.90154 11.3277 7.90154 11.7215 8.29537L16 12.5738L17.4262 14Z\" fill=\"#FAFAFA\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol